import React, { useCallback, useEffect } from "react";
import { useMemo, useState } from "react";
import { Image } from "react-native";
import { Text, View } from "@constants/Themed";
import SwitchWithIcons from "react-native-switch-with-icons";
import * as Animatable from 'react-native-animatable';
import apis from "@api/api";
import styles from "@stylesheet";
import toTitleCase from "@hooks/toTitleCase";
import AvatarHandler from "@components/Global/AvatarHandler/AvatarHandler";

type UserItemTypes = {
  item: any,
  index: number,
  callback?: Function
}

const UserPermissionItem = ({ item, index, callback }: UserItemTypes) => {
  const [filter, setFilter] = useState(false);
  const [filterEnabled, setFilterEnabled] = useState(true);
  const [itemData, setItemData] = useState();



  const handleChange = useCallback((value) => {
    if (callback) {
      callback(item, value);
    }
    setFilter(!filter);
  }, [filter]);

  return (
    <Animatable.View
      useNativeDriver
      animation={'fadeInUp'}
      delay={index * 100}
      style={{
        flexDirection: 'row',
        alignSelf: 'stretch',
        alignItems: 'center',
        marginVertical: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        backgroundColor: 'rgba(90, 192, 234, 0.05)',
        borderRadius: 12,
        borderLeftWidth: 3,
        borderLeftColor: 'rgb(90, 192, 234)'
      }}
    >
      <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', gap: 12 }}>
        <View style={{ width: 45, height: 45 }}>
          <AvatarHandler
            avatar={item.profile_information?.avatar?.img || item.avatar?.img}
          />
        </View>
        <View style={{ flex: 1, justifyContent: 'center' }}>
          {
            item.email || item.profile_information?.name ?
              <>
                <Text style={{
                  fontWeight: '600',
                  fontSize: 16,
                  marginBottom: 2
                }} numberOfLines={1}>
                  {toTitleCase(item.name || item.profile_information.name) + " " + toTitleCase(item.surname || item.profile_information.surname)}
                </Text>
                <Text style={{
                  fontSize: 14,
                  opacity: 0.7,
                  fontWeight: '400'
                }} numberOfLines={1}>
                  {item.email || item?.profile_information?.email}
                </Text>
              </>
              :
              <>
                <Text style={{
                  fontWeight: '600',
                  fontSize: 16,
                  marginBottom: 2
                }} numberOfLines={1}>
                  {toTitleCase(item.value)}
                </Text>
                <Text style={{
                  fontStyle: 'italic',
                  fontSize: 13,
                  opacity: 0.6
                }}>
                  New invite will be sent
                </Text>
              </>
          }
        </View>
      </View>

      <View style={{
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        minWidth: 80
      }}>
        <SwitchWithIcons 
          value={filter}
          trackColor={{ false: '#58BFEA', true: '#58BFEA' }}
          thumbColor={{ false: '#ffffff', true: '#ffffff' }}
          animationDuration={200}
          style={{
            transform: [{ scale: 0.9 }]
          }}
          icon={{ false: 'eye', true: 'edit' }}
          onValueChange={(value) => handleChange(value)}
        />
        <Text style={{
          textAlign: "center",
          fontSize: 12,
          fontWeight: '500',
          color: 'rgb(90, 192, 234)'
        }}>
          {filter ? 'Edit' : 'View'}
        </Text>
      </View>
    </Animatable.View>
  )
};

export default UserPermissionItem;